import { network } from 'services/network';

export const createPoapView = (params) => {
    return network.post('api/bo/createPoapView', params).then((response) => response.data);
};
